import React, { useEffect } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Layout from "../../Layout";
import { Data } from "../../../store/merchantStaging/types";
import { getById } from "../../../store/merchantStaging/queries";
import { fetchRequest as fetchMerchantStage } from "../../../store/merchantStaging/actions";
import useSession from "../../../effects/useSession";
import pageStyles from "../../pageStyles";
import PageHeading from "../../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import { Box } from "@mui/material";
import MerchantStageViewDetail from "./MerchantStageViewDetail";

export default function MerchantStageView() {
  const dispatch = useDispatch();
  const classes = pageStyles();
  const { id } = useParams<{ id: string }>();
  console.log("id", !isNil(id))
  const session = useSession();

  useEffect(() => {
    !isNil(id) && dispatch(fetchMerchantStage(id));
  }, []);

  const merchant = useSelector(id ? getById(id) : () => null) as Data;

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid xs={12}>
              <Paper>
                <PageHeading heading="View Staged Terminal" />
              </Paper>
            </Grid>

            <Grid xs={12}>
              <Paper className={classes.paper}>
                {!isNil(id) && isNil(merchant) ? (
                  <ProgressIndicator />
                ) : (
                  <Box style={{ position: "relative" }}>
                    <MerchantStageViewDetail merchantStageData={merchant}/>
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
